import Link from 'next/link';
import React from 'react';
import { Transition } from '@headlessui/react';
import { ArrowRightIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import { useAnalytics } from 'use-analytics';
import { ProductItem } from './ProductsBar';

const MenuItems: ProductItem[] = [
  {
    label: 'Recruitment agencies',
    href: '/recruitmentagency',
    active: true,
  },
  {
    label: 'Fintech & financial institutions',
    href: '/fintech',
    active: true,
  },
  {
    label: 'Talent marketplaces',
    href: '/talent-marketplace',
    active: true,
  },
  {
    label: 'Automitive & mobility',
    href: '/',
    active: false,
  },
  {
    label: 'Construction firms and marketplaces',
    href: '/',
    active: false,
  },
];

type Props = {
  isOpen: boolean;
};

export const UsecasesBar = ({ isOpen }: Props) => {
  return (
    <div className="relative hidden w-full items-center justify-center md:block">
      <Transition
        show={isOpen}
        enter="transition-opacity duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100 border-t"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        className="absolute top-0 left-0 w-full bg-white shadow-md"
      >
        <ul className="container  flex list-none items-center justify-evenly py-2 text-sm font-semibold">
          <li className="mx-6 h-4"></li>
          <ProductsList />
        </ul>
      </Transition>
    </div>
  );
};

export const UsecasesBarMobile = () => {
  return (
    <div className="mt-5">
      <h3 className="text-[22px] text-white">Usecases</h3>
      <ul className="mt-3 flex flex-col">
        <ProductsList isMobile={true} />
      </ul>
    </div>
  );
};

type ProductsListProps = {
  isMobile?: boolean;
};

const ProductsList = ({ isMobile }: ProductsListProps) => {
  const { track } = useAnalytics();
  const itemClassName = clsx('block cursor-not-allowed px-4 py-2 capitalize', {
    'text-gray-400': !isMobile,
    'text-white/30': isMobile,
  });
  const activeItemClassName = clsx('block px-4 py-2 capitalize', {
    'text-gray-dark hover:text-brand-primary transition-colors duration-75':
      !isMobile,
    'text-base font-semibold text-white': isMobile,
  });

  return (
    <>
      {MenuItems.map((item) => (
        <li key={item.label}>
          {item.active ? (
            <Link
              href={item.href}
              className={activeItemClassName}
              target={item.external ? '_blank' : '_self'}
              onClick={() => {
                track('click_nav_link', {
                  label: item.label,
                  href: item.href,
                });
              }}
            >
              {item.label}
              <ArrowRightIcon className="ml-2 inline-block h-4" />
            </Link>
          ) : (
            <p className={itemClassName}>
              {item.label}
              <span className="block font-normal">Coming soon</span>
            </p>
          )}
        </li>
      ))}
    </>
  );
};
